export default function ErrorBanner({ children }) {
  return (
    <div
      className="fixed bottom-4 left-1/2 z-50 flex max-h-[80vh] max-w-[95vw] -translate-x-1/2 items-center gap-3 overflow-auto
                 rounded-lg border border-red-300/60 bg-red-800 px-4 py-3 text-xs text-white/90 shadow-lg dark:border-red-700/60 dark:bg-red-200
                 dark:text-zinc-900/90 sm:text-sm"
      role="alert"
      aria-live="assertive"
    >
      {children}
    </div>
  );
}
